import React from 'react';

const TopLeft2Shape = ({ className }) => {
  return (
    <svg 
        className={className}
        width="132"
        height="50" 
        viewBox="0 0 132 50" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M0.874003 46.84C9.84802 47.3567 117.282 51.348 129.214 -81.5" 
            stroke="#9DBCC5" 
            stroke-width="4.5"
        />
    </svg>
  );
};

export default TopLeft2Shape;


